import React from 'react';

import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiSettings } from '@lumapps/lumx/icons';
import { useTranslate } from '@lumapps/translations';

import { MOBILE_GENERAL_SETTINGS } from '../../keys';
import { mobileGeneralSettingsRoute } from '../../routes';

export interface MobileGeneralSettingsSideNavigationProps extends Partial<SideNavigationItemProps> {
    isAllowed: boolean;
}

const MobileGeneralSettingsSideNavigation = ({
    isAllowed,
    ...restOfProps
}: MobileGeneralSettingsSideNavigationProps) => {
    const { translateKey } = useTranslate();

    if (!isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem
            {...restOfProps}
            label={translateKey(MOBILE_GENERAL_SETTINGS.TITLE)}
            icon={mdiSettings}
            route={mobileGeneralSettingsRoute}
        />
    );
};

MobileGeneralSettingsSideNavigation.displayName = 'SideNavigationItem';

export { MobileGeneralSettingsSideNavigation };
